import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { AdUnitForProductTableDTO } from './types'

export const AD_UNIT_FOR_PRODUCT_TABLE_FRAGMENT: TypedDocumentNode<AdUnitForProductTableDTO> = gql`
  fragment AdUnitForProductTableFragment on AdUnit {
    divId
    id
    name
    outOfPage
    path
    prebidStackEnabled
    priceGeniusEnabled
    refresherEnabled
    unfilledRecoveryEnabled
    updatedAt
    viewabilityToolsEnabled
  }
`
